import { render, staticRenderFns } from "./mtcHeader.vue?vue&type=template&id=7495a92a&"
import script from "./mtcHeader.vue?vue&type=script&lang=js&"
export * from "./mtcHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports